import React, { useState, useEffect, useRef, Fragment } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader, MenuItem, TableBody,
  TableCell,
  TableHead,
  TableRow,
  Table,
  Hidden,
  TableContainer,
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Formik } from 'formik';
import PageHeader from 'src/views/Common/PageHeader';
import { LoadingComponent } from '../../../utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../utils/permissionAuth';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker } from '@material-ui/pickers';
import PaymentVoucherPDF from './PaymentVoucherPDF';
import ReactToPrint from 'react-to-print';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  }
}));

var screenCode = 'INVOICEPAYMENTAPPROVAL';
export default function InvoicePaymentApprovalView(props) {
  const {
    accountID,
    startDate,
    endDate,
    referenceNumber,
    IsGuestNavigation
  } = useParams();
  const componentRef = useRef();
  const { groupID } = useParams();
  const { factoryID } = useParams();

  const classes = useStyles();
  const [factories, setFactories] = useState(); const navigate = useNavigate();
  const [title, setTitle] = useState('Payment Payment Approval');
  const [groups, setGroups] = useState([]);
  const [selectedDate, handleDateChange] = useState(new Date().toISOString());
  const [journalData, setJournalData] = useState([]);
  const [creditSumJournalData, setCreditSumJournalData] = useState([]);
  const [allJournalData, setAllJournalData] = useState([]);
  const [voucherTypes, setVoucherTypes] = useState([]);
  const [tranLedgerList, setTranLedgerList] = useState([]);
  const [suppliers, setSuppliers] = useState();
  const [supplierCommon, setSupplierCommon] = useState(false);
  const [accountDescriptionsTypeAll, setAccountDescriptionsTypeAll] = useState({});
  const [refNo, setRefNo] = useState("");
  const [status, setStatus] = useState(0);
  const [suppliersPaymentID, setSuppliersPaymentID] = useState({
    paymentTypeID: '0'
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });
  const location = useLocation();
  const { generalJournalList: generalJournalList } = location.state || {};
  const [generalJournal, setGeneralJournal] = useState({
    groupID: '0',
    groupName: '',
    factoryID: '0',
    transactionTypeID: '0',
    referenceNumber: '',
    description: '',
    desc: '',
    remark: '',
    payModeID: '0',
    chequeNumber: '',
    isActive: true,
    preparedBy: '',
    updatedBy: '',
    checkedBy: '',
    voucherType: '0',
    voucherCode: '',
    transactionMode: '0',
    recipientName: '',
    address: '',
    isInterEstate: false,
    interEstateID: '0',
    tranLedgerAccountID: '0',
    supplierID: '0',
    payee: '',
    modeoftransactionID: '0',
    modeoftransactionNumber: '',
    status: '0'
  });
  const [QuaryParamDetails, setQuaryParamDetails] = useState({
    groupID: '',
    factoryID: '',
    accountID: '',
    startDate: '',
    endDate: '',
    referenceNumber: '',
    IsGuestNavigation: '0'
  });
  const [totalValues, setTotalValues] = useState({
    totalAmount: 0
  });

  let decrypted = 0;

  const handleClickBack = () => {
    if (QuaryParamDetails.IsGuestNavigation === '1') {
      const encryptedGroupID = btoa(QuaryParamDetails.groupID.toString());
      const encryptedFactoryID = btoa(QuaryParamDetails.factoryID.toString());
      const encryptedStartDate = btoa(QuaryParamDetails.startDate.toString());
      const encryptedEndDate = btoa(QuaryParamDetails.endDate.toString());
      const encryptedAccountID = btoa(QuaryParamDetails.accountID.toString());

      navigate(
        '/app/ledgerAccountReviewing/' +
        encryptedGroupID +
        '/' +
        encryptedFactoryID +
        '/' +
        encryptedAccountID +
        '/' +
        encryptedStartDate +
        '/' +
        encryptedEndDate +
        '/' +
        btoa('1')
      );
    } else {
      navigate('/app/invoicePaymentApproval/listing');
    }
  };
  const [printDate, setPrintDate] = useState('');
  const [supplierNamePDF, setSupplierNamePDF] = useState("Unknown Supplier");
  useEffect(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toLocaleString();
    setPrintDate(formattedDate);
  }, []);

  useEffect(() => {
    trackPromise(getPermissions());
    trackPromise(getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(getfactoriesForDropDown());
  }, [generalJournal.groupID]);

  useEffect(() => {
    trackPromise(getTransactionTypes());
    trackPromise(getVoucherTypeList());
    trackPromise(getTransactionModeList());
    trackPromise(getTranLedgerList());
  }, [generalJournal.factoryID]);

  useEffect(() => {
    decrypted = atob(referenceNumber.toString());
    const decrypedGroupID = atob(groupID.toString());
    const decrypedFactoryID = atob(factoryID.toString());
    const decrypedAccountID = atob(accountID.toString());
    const decrypedStartDate = atob(startDate.toString());
    const decrypedEndDate = atob(endDate.toString());
    const decrypedIsGuestNavigation = atob(IsGuestNavigation.toString());
    setQuaryParamDetails({
      groupID: decrypedGroupID,
      factoryID: decrypedFactoryID,
      accountID: decrypedAccountID,
      startDate: decrypedStartDate,
      endDate: decrypedEndDate,
      referenceNumber: decrypted,
      IsGuestNavigation: decrypedIsGuestNavigation
    });
    if (decrypted != 0) {
      trackPromise(
        getGeneralJournalDetails(decrypted, decrypedGroupID, decrypedFactoryID)
      );
    }
  }, []);

  useEffect(() => {
    if (generalJournal.transactionTypeID != 0) {
      trackPromise(getReferenceNumber());
    }
  }, [generalJournal.transactionTypeID]);

  useEffect(() => {
    if (generalJournal.factoryID.toString() !== '0') {
      trackPromise(getSuppliersForDropDown());
      trackPromise(getSuppliersPaymentID());
    }
  }, [generalJournal.factoryID]);

  useEffect(() => {
    if (journalData.length != 0) {
      calculateTotal();
    }
  }, [journalData]);

  async function getReferenceNumber() {
    if (
      generalJournal.referenceNumber < 1 ||
      generalJournal.referenceNumberk == '' ||
      generalJournal.referenceNumber == undefined
    ) {
      let refModel = {
        groupID: generalJournal.groupID,
        factoryID: generalJournal.factoryID,
        transactionTypeID: generalJournal.transactionTypeID,
        isActive: true
      };
      const ref = await services.getReferenceNumber(refModel);
      setGeneralJournal({ ...generalJournal, referenceNumber: ref });
    }
  }

  async function getTransactionTypes() {
    const transaction = await services.getTransactionTypeNamesForDropdown();
  }

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(
      p => p.permissionCode == 'ADDEDITGURUGODALLAPAYMENTINVOICEAPPROVAL'
    );

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(
      p => p.permissionCode == 'GROUPDROPDOWN'
    );
    var isFactoryFilterEnabled = permissions.find(
      p => p.permissionCode == 'FACTORYDROPDOWN'
    );

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setGeneralJournal({
      ...generalJournal,
      groupID: parseInt(generalJournalList.groupID),
      factoryID: parseInt(generalJournalList.factoryID),
    });
  }

  async function getfactoriesForDropDown() {
    const factory = await services.getfactoriesForDropDown(
      QuaryParamDetails.groupID
    );
    setFactories(factory);
  }

  async function getSuppliersPaymentID() {
    const result = await services.getSuppliersPaymentID(generalJournal.groupID);
    result.forEach(item => {
      setSuppliersPaymentID(suppliersPaymentID => ({
        ...suppliersPaymentID,
        paymentTypeID: item.paymentTypeID
      }));
    });
  }

  async function getGeneralJournalDetails(referenceNumber, groupID, factoryID) {
    let response = await services.getGeneralJournalDetailsByReferenceNumber(
      referenceNumber,
      groupID,
      factoryID
    );
    let data = response;
    const [desc, remark] = data[0].description.split("Rejecting Remark :-");
    setTitle('View Invoice Payment');
    setGeneralJournal({
      ...generalJournal,
      groupID: data[0].groupID,
      factoryID: data[0].factoryID,
      transactionTypeID: data[0].transactionTypeID,
      description: data[0].description == null ? '' : data[0].description,
      desc: desc,
      remark: remark,
      payModeID: data[0].payModeID,
      chequeNumber: data[0].chequeNumber == null ? '' : data[0].chequeNumber,
      preparedBy: data[0].preparedBy,
      updatedBy: data[0].updatedBy,
      referenceNumber: data[0].referenceNumber,
      recipientName: data[0].recipientName,
      transactionMode: data[0].transactionModeID,
      voucherType: data[0].voucherTypeID,
      chequeNumber: data[0].chequeNumber == null ? '' : data[0].chequeNumber,
      checkedBy: data[0].checkedBy,
      isInterEstate: data[0].isInterEstate,
      interEstateID: data[0].interEstateID,
      supplierID: data[0].supplierID,
      tranLedgerAccountID: data[0].tranLedgerAccountID,
      groupName: data[0].groupName,
      estateName: data[0].estateName,
      invoiceNumber: data[0].invoiceNumber,
      modeoftransactionNumber: data[0].modeoftransactionNumber,
      modeoftransactionID: data[0].modeoftransactionID,
      payee: data[0].payee,
      status: data[0].status
    });
    setStatus(data[0].status);
    handleDateChange(new Date(data[0].date).toISOString());
    let tranLedgerAccountID = data[0].tranLedgerAccountID;

    let copyArray = data;

    setAllJournalData(copyArray)
    let tempArray = [...journalData]
    let tempArray1 = [...journalData]
    let creditSumArray = copyArray.filter((x) => x.accountTypeName === tranLedgerAccountID);
    setCreditSumJournalData(creditSumArray)
    copyArray.forEach(element => {
      const [desc, remark] = element.description.split("Rejecting Remark :-");
      tempArray.push(
        {
          accountTypeName: element.accountTypeName,
          description: element.description,
          desc: desc,
          remark: remark,
          credit: element.credit,
          debit: element.debit,
          estateName: element.estateName,
          invoiceNumber: element.invoiceNumber,
          invoiceDetailID: element.invoiceDetailID,
          ledgerTransactionID: element.ledgerTransactionID,
          rowID: 0,
          ledgerAccountCode: element.ledgerAccountCode,
          ledgerAccountName: element.ledgerAccountName,
          descriptionTypeID: element.descriptionTypeID,
          childHeaderName: element.childHeaderName,
        }

      )
    });
    setJournalData(tempArray)
    copyArray.forEach(element => {
      getAccountDescriptionsALL(element.accountTypeName)
      tempArray1.push(
        {
          accountTypeName: element.accountTypeName,
          description: element.description,
          descriptionTypeID: element.descriptionTypeID,
          credit: element.credit,
          debit: element.debit,
          ledgerTransactionID: element.ledgerTransactionID,
          descriptionTypeID: element.descriptionTypeID,
          rowID: 0,
        }
      )
    });
  }

  async function getGroupsForDropdown() {
    const groups = await services.getGroupsForDropdown();
    setGroups(groups);
  }

  async function getTransactionModeList() {
    const transactionModes = await services.getTransactionModeList();
    return transactionModes;
  }

  async function getVoucherTypeList() {
    const voucherTypes = await services.getVoucherTypeList();
    setVoucherTypes(voucherTypes);
    return voucherTypes;
  }

  async function getTranLedgerList() {
    const transaction = await services.getTranLedgerListForDropdown(
      generalJournalList.factoryID
    );
    setTranLedgerList(transaction);
  }

  async function getSuppliersForDropDown() {
    const supplier = await services.getSuppliersForDropDown(
      generalJournalList.factoryID
    );
    setSuppliers(supplier);
  }

  function calculateTotal() {
    const totalAmount = journalData.reduce((accumulator, current) => {
      const progressFraction = current.debit;
      return accumulator + progressFraction;
    }, 0);

    setTotalValues({
      ...totalValues,
      totalAmount: totalAmount
    });
  }

  function changeText(e, rowID, inputType, IDvalue = 0, desc = null) {
    let target = e?.target ? e.target : '';
    let value = target !== '' ? target.value : '';
    const newArr = [...journalData];
    var idx = newArr.findIndex(e => e.rowID == parseInt(rowID));
    const AccountTypeName = newArr[idx].accountTypeName;
    for (let i = 0; i < newArr.length; i++) {
      if (i !== idx && newArr[i].accountTypeName === AccountTypeName) {
        if (inputType === 'credit' && parseInt(newArr[i].debit) !== 0) {
          alert.error('No Credit amounts are allowed for this Account.');
          return;
        }
        else if (inputType === 'debit' && parseInt(newArr[i].credit) !== 0) {
          alert.error('No Debit amounts are allowed for this Account.');
          return;
        }
      }
    }
    if (inputType === "description") {
      newArr[idx] = { ...newArr[idx], description: value };
    }
    else if (inputType.includes('descriptionType')) {
      newArr[idx] = { ...newArr[idx], descriptionType: desc, descriptionTypeID: IDvalue };
    }
    else if (inputType === 'credit') {
      var reg = new RegExp('^[.0-9]*$');
      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }
      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = true;
        creditBool = false;
      }
      if (value.toString().length > 18) {
        alert.error('Allow Only 18 Numbers');
        return;
      }
      newArr[idx] = {
        ...newArr[idx],
        credit: value === '' ? 0 : value,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    } else {
      var reg = new RegExp('^[.0-9]*$');

      if (reg.test(value) == false) {
        alert.error('Allow Only Numbers');
        return;
      }
      let debitBool = false;
      let creditBool = false;
      if (parseFloat(value.toString()) > 0) {
        debitBool = false;
        creditBool = true;
      }
      if (value.toString().length > 20) {
        alert.error('Allow Only 20 Numbers');
        return;
      }
      newArr[idx] = {
        ...newArr[idx],
        debit: IDvalue === '' ? 0 : IDvalue,
        disableCreditField: creditBool,
        disableDebitField: debitBool
      };
    }
    setJournalData(newArr);
  }

  function onKeyDown(e, id, data) {
    if (e.key === "Tab") {
      if (data.credit != 0 || data.debit != 0) {
        if (journalData[journalData.length - 1].rowID.toString() === id.toString()) {
          let ID = GenerateRandomID()
          journalData.push({ accountTypeName: 0, credit: 0, debit: 0, ledgerTransactionID: 0, rowID: ID, selected: [] })
          var result = refNo == undefined ? 0 : refNo.substring(0, 3);
          setJournalData(journalData)
          if (result == 'CHP') {
            getChequeNumber(data)
          }
        }
      }
      else {
        alert.error("please enter amount");
      }
    }
  };

  function GenerateRandomID() {
    const d = new Date();
    let ms = d.valueOf();

    let rendomValue =
      ms + Math.floor(Math.random() * 10000) - 12 + (ms - 128 + ms * 512);
    return rendomValue;
  }

  async function getChequeNumber(data) {
    let response = await services.getChequeNumber(data.accountTypeName);
    if (response.data == null) {
      alert.error(response.message);
    } else {
      setGeneralJournal({
        ...generalJournal,
        chequeNumber: response.data
      });
    }
  }

  async function getAccountDescriptionsALL(tranLedgerAccountID) {
    const accountDescriptions = await services.getAccountDescriptionsAll(tranLedgerAccountID);
    setAccountDescriptionsTypeAll(accountDescriptions);
  }

  function generateDropDownMenu(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function generateDropDownMenuWithTwoValues(data) {
    let items = [];
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(
          <MenuItem key={key} value={key}>
            {value.name}
          </MenuItem>
        );
      }
    }
    return items;
  }

  function handleChange1(e) {
    const target = e.target;
    const value = target.value;
    setGeneralJournal({
      ...generalJournal,
      [e.target.name]: value
    });
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
        <Grid item md={2} xs={12}>
          <PageHeader onClick={handleClickBack} />
        </Grid>
      </Grid>
    );
  }

  function generateDropownForVoucherList(dataList) {
    let items = [];
    if (dataList != null) {
      voucherTypes.forEach(x => {
        items.push(
          <MenuItem key={x.voucherTypeID} value={x.voucherTypeID}>
            {x.voucherTypeName}
          </MenuItem>
        );
      });
    }
    return items;
  }

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: generalJournal.groupID,
              factoryID: generalJournal.factoryID,
              transactionTypeID: generalJournal.transactionTypeID,
              referenceNumber: generalJournal.referenceNumber,
              description: generalJournal.description,
              payModeID: generalJournal.payModeID,
              chequeNumber: generalJournal.chequeNumber,
              isActive: generalJournal.isActive,
              tranLedgerAccountID: generalJournal.tranLedgerAccountID,
              supplierID: generalJournal.supplierID,
              payee: generalJournal.payee,
              status: generalJournal.status
            }}
            enableReinitialize
          >
            {({ errors, handleBlur, handleSubmit, touched, values }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChange1(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.factoryID && errors.factoryID
                              )}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              size="small"
                              onBlur={handleBlur}
                              onChange={e => handleChange1(e)}
                              value={generalJournalList.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel
                              shrink
                              id="date"
                              style={{ marginBottom: '-8px' }}
                            >
                              Date *
                            </InputLabel>

                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <KeyboardDatePicker
                                fullWidth
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                margin="dense"
                                id="date-picker-inline"
                                value={selectedDate}
                                onChange={e => {
                                  handleDateChange(e);
                                }}
                                KeyboardButtonProps={{
                                  'aria-label': 'change date'
                                }}
                                autoOk
                                disabled="true"
                                InputProps={{
                                  readOnly: true
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>
                        </Grid>
                        <Grid container spacing={3}>
                          {Hidden == true ? (
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="voucherType">
                                Voucher Type *
                              </InputLabel>
                              <TextField
                                select
                                error={Boolean(
                                  touched.voucherType && errors.voucherType
                                )}
                                fullWidth
                                helperText={
                                  touched.voucherType && errors.voucherType
                                }
                                name="voucherType"
                                size="small"
                                onBlur={handleBlur}
                                value={generalJournal.voucherType}
                                variant="outlined"
                                id="voucherType"
                                InputProps={{
                                  readOnly: true
                                }}
                              >
                                <MenuItem value="0">
                                  --Select Voucher Type--
                                </MenuItem>
                                {generateDropownForVoucherList(voucherTypes)}
                              </TextField>
                            </Grid>
                          ) : null}
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="tranLedgerAccountID">
                              Bank Account *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              )}
                              fullWidth
                              helperText={
                                touched.tranLedgerAccountID &&
                                errors.tranLedgerAccountID
                              }
                              name="tranLedgerAccountID"
                              size="small"
                              onBlur={handleBlur}
                              value={generalJournal.tranLedgerAccountID}
                              variant="outlined"
                              id="tranLedgerAccountID"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                              <MenuItem value="0">
                                --Select Ledger Account--
                              </MenuItem>
                              {generateDropDownMenu(tranLedgerList)}
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="referenceNumber">
                              Voucher Code *
                            </InputLabel>
                            <TextField
                              error={Boolean(
                                touched.referenceNumber &&
                                errors.referenceNumber
                              )}
                              fullWidth
                              helperText={
                                touched.referenceNumber &&
                                errors.referenceNumber
                              }
                              name="referenceNumber"
                              size="small"
                              onBlur={handleBlur}
                              value={generalJournal.referenceNumber}
                              variant="outlined"
                              InputProps={{
                                readOnly: true
                              }}
                            />
                          </Grid>
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="supplierID">
                              Supplier *
                            </InputLabel>
                            <TextField
                              select
                              error={Boolean(
                                touched.supplierID && errors.supplierID
                              )}
                              fullWidth
                              helperText={
                                touched.supplierID && errors.supplierID
                              }
                              name="supplierID"
                              size="small"
                              onBlur={handleBlur}
                              value={generalJournal.supplierID}
                              variant="outlined"
                              id="supplierID"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                              <MenuItem value="0">--Select Supplier--</MenuItem>
                              {generateDropDownMenuWithTwoValues(suppliers)}
                            </TextField>
                          </Grid>
                          {supplierCommon ? (
                            <Grid item md={4} xs={12}>
                              <InputLabel shrink id="payee">
                                Payee *
                              </InputLabel>
                              <TextField
                                error={Boolean(touched.payee && errors.payee)}
                                fullWidth
                                helperText={touched.payee && errors.payee}
                                name="payee"
                                size="small"
                                onBlur={handleBlur}
                                value={generalJournal.payee}
                                variant="outlined"
                                id="payee"
                                InputProps={{
                                  readOnly: true
                                }}
                              />
                            </Grid>
                          ) : null}
                          <Grid item md={4} xs={12}>
                            <InputLabel shrink id="modeoftransactionID">
                              Mode of transaction
                            </InputLabel>
                            <TextField
                              select
                              name="modeoftransactionID"
                              size="small"
                              fullWidth
                              onBlur={handleBlur}
                              onChange={e => {
                                handleChange1(e);
                              }}
                              value={generalJournal.modeoftransactionID}
                              variant="outlined"
                              id="modeoftransactionID"
                              InputProps={{
                                readOnly: true
                              }}
                            >
                              <MenuItem value="0">
                                --Select Transaction Mode--
                              </MenuItem>
                              <MenuItem value="3"> Cheque </MenuItem>
                              <MenuItem value="7"> Fund Transfer </MenuItem>
                            </TextField>
                          </Grid>
                          {
                            generalJournal.modeoftransactionID > 0 &&
                              generalJournal.modeoftransactionID != 3 ? (
                              <Grid item md={4} xs={12}>
                                {generalJournal.modeoftransactionID == 1 ? (
                                  <InputLabel shrink id="modeoftransactionNumber">
                                    Cheque Number
                                  </InputLabel>
                                ) : (
                                  <InputLabel shrink id="modeoftransactionNumber">
                                    Fund Transfer Number
                                  </InputLabel>
                                )}
                                <TextField
                                  error={Boolean(
                                    touched.modeoftransactionNumber &&
                                    errors.modeoftransactionNumber
                                  )}
                                  fullWidth
                                  helperText={
                                    touched.modeoftransactionNumber &&
                                    errors.modeoftransactionNumber
                                  }
                                  name="modeoftransactionNumber"
                                  size="small"
                                  onBlur={handleBlur}
                                  onChange={e => handleChange1(e)}
                                  value={generalJournal.modeoftransactionNumber}
                                  variant="outlined"
                                  InputProps={{
                                    readOnly: true
                                  }}
                                />
                              </Grid>
                            ) : null}
                        </Grid>
                      </CardContent>

                      <CardContent height="auto" width="auto">
                        <Box style={{ border: '1px solid gray', overflowX: 'auto' }}>
                          <TableContainer style={{ overflowX: 'auto' }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Factory Name</TableCell>
                                  <TableCell>Account Name</TableCell>
                                  <TableCell>Description</TableCell>
                                  <TableCell>Description Category</TableCell>
                                  <TableCell>Invoice Number</TableCell>
                                  <TableCell>Debit</TableCell>
                                  <TableCell>Credit</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {journalData.map((object) => {
                                  let ID = object.rowID;
                                  return (
                                    <TableRow key={ID}>
                                      <TableCell style={{ padding: "5px", width: "10rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          style={{ width: "10rem" }}
                                          name={ID}
                                          onBlur={handleBlur}
                                          value={object.estateName}
                                          InputProps={{ readOnly: true }}
                                          fullWidth
                                        />
                                      </TableCell>
                                      <TableCell style={{ padding: "5px", width: "10rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          style={{ width: "10rem" }}
                                          name={ID}
                                          onBlur={handleBlur}
                                          value={object.ledgerAccountName}
                                          InputProps={{ readOnly: true }}
                                          fullWidth
                                        />
                                      </TableCell>
                                      <TableCell style={{ padding: "16px", width: "15rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          placeholder="--Enter Description --"
                                          name={ID}
                                          onBlur={handleBlur}
                                          onChange={(e) => changeText(e, ID, "description")}
                                          value={object.desc}
                                          InputProps={{ readOnly: true }}
                                          fullWidth
                                        />
                                      </TableCell>
                                      <TableCell style={{ padding: "5px", width: "5rem" }}>
                                        <TextField
                                          select
                                          name="descriptionType"
                                          size="small"
                                          onBlur={handleBlur}
                                          value={object.descriptionTypeID}
                                          variant="outlined"
                                          id="descriptionType"
                                          InputProps={{ readOnly: true }}
                                        >
                                          <MenuItem value="0">--Select Description Type--</MenuItem>
                                          {generateDropDownMenu(accountDescriptionsTypeAll)}
                                        </TextField>
                                      </TableCell>
                                      <TableCell style={{ padding: "5px", width: "5rem" }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          style={{ width: "5rem" }}
                                          name={ID}
                                          onBlur={handleBlur}
                                          value={object.invoiceNumber}
                                          InputProps={{ readOnly: true }}
                                          fullWidth
                                        />
                                      </TableCell>
                                      <TableCell style={{ verticalAlign: "top", width: '15rem' }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          name={ID}
                                          onBlur={handleBlur}
                                          fullWidth
                                          onChange={(e) => changeText(e, ID, 'debit', e.target.value)}
                                          value={object.debit}
                                          onKeyDown={(e) => onKeyDown(e, ID, object)}
                                          inputProps={{
                                            readOnly: true
                                          }}
                                        />
                                      </TableCell>
                                      <TableCell style={{ verticalAlign: "top", width: '15rem' }}>
                                        <TextField
                                          variant="outlined"
                                          size="small"
                                          name={ID}
                                          onBlur={handleBlur}
                                          fullWidth
                                          onChange={(e) => changeText(e, ID, 'credit', e.target.value)}
                                          value={object.credit}
                                          onKeyDown={(e) => onKeyDown(e, ID, object)}
                                          inputProps={{
                                            readOnly: true
                                          }}
                                        />
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Box>
                        {status == 3 ?
                          <>
                            <Grid container spacing={3} style={{ marginTop: "0.5rem" }}>
                              <Grid item md={6} xs={12}>
                                <InputLabel shrink id="rejectRemark">
                                  Rejecting Remark *
                                </InputLabel>
                                <TextField
                                  fullWidth
                                  size='small'
                                  name="rejectRemark"
                                  onBlur={handleBlur}
                                  readOnly={true}
                                  value={generalJournal.remark}
                                  variant="outlined"
                                  id="rejectRemark"
                                  multiline
                                  rows={3}
                                />
                              </Grid>
                            </Grid>
                          </>
                          : null}
                      </CardContent>

                      <CardContent>
                      </CardContent>
                      <Box display="flex" justifyContent="flex-end" p={2}>
                        <div>&nbsp;</div>
                        {
                          <ReactToPrint
                            documentTitle={
                              generalJournal.referenceNumber +
                              ' - Payment Voucher'
                            }
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            content={() => componentRef.current}
                          />
                        }
                        {
                          <div hidden={true}>
                            <PaymentVoucherPDF
                              ref={componentRef}
                              generalJournal={generalJournal}
                              suppliersPaymentID={suppliersPaymentID}
                              selectedDate={selectedDate}
                              journalData={journalData}
                              suppliers={suppliers}
                              printDate={printDate}
                              totalValues={totalValues}
                              supplierNamePDF={supplierNamePDF}
                              generalJournalList={generalJournalList}
                              creditSumJournalData={creditSumJournalData}
                              allJournalData={allJournalData}
                            />
                          </div>
                        }
                      </Box>
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
